import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UITag from 'UIComponents/tag/UITag';
import styled from '../../../components/Theme';
import { FilterQuery } from '../../../consts';
import { useFilter, useJSONFilter } from '../../../utils/hooks';
const FilterTagsWrapper = styled.div.withConfig({
  displayName: "FilterTags__FilterTagsWrapper",
  componentId: "sc-1lx0rhx-0"
})(["&:not(:empty){margin-bottom:16px;}display:flex;align-items:center;flex-wrap:wrap;"]);
const ClickableTag = styled(UITag).withConfig({
  displayName: "FilterTags__ClickableTag",
  componentId: "sc-1lx0rhx-1"
})(["& *{text-decoration:none !important;font-weight:600;}margin-left:0 !important;margin-right:12px;margin-bottom:8px;"]);
const ClearButton = styled(UILink).withConfig({
  displayName: "FilterTags__ClearButton",
  componentId: "sc-1lx0rhx-2"
})(["margin-bottom:8px;"]);

const FilterTags = () => {
  const {
    selectedItems: products,
    handleToggle: handleToggleProducts,
    handleClear: handleClearProducts
  } = useFilter(FilterQuery.products);
  const {
    selectedItems: goals,
    handleToggle: handleToggleGoals,
    handleClear: handleClearGoals
  } = useFilter(FilterQuery.goals);
  const {
    selectedObjects: locations,
    handleClear: handleClearLocations
  } = useJSONFilter(FilterQuery.location);
  const {
    selectedObjects: industries,
    handleClear: handleClearIndustries
  } = useJSONFilter(FilterQuery.industry);
  const {
    selectedObjects: companies,
    handleClear: handleClearCompanies
  } = useJSONFilter(FilterQuery.company);
  return /*#__PURE__*/_jsxs(FilterTagsWrapper, {
    children: [products.map(product => /*#__PURE__*/_jsx(ClickableTag, {
      closeable: true,
      onClick: () => handleToggleProducts(product),
      onCloseClick: () => handleToggleProducts(product),
      "data-test-id": "filter-tag",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `connectDotCom.hubs.${product}`
      })
    }, product)), goals.map(goal => /*#__PURE__*/_jsx(ClickableTag, {
      closeable: true,
      onClick: () => handleToggleGoals(goal),
      onCloseClick: () => handleToggleGoals(goal),
      "data-test-id": "filter-tag",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `connectDotCom.goals.${goal}`
      })
    }, goal)), locations.map(location => /*#__PURE__*/_jsx(ClickableTag, {
      closeable: true,
      onClick: handleClearLocations,
      onCloseClick: handleClearLocations,
      "data-test-id": "filter-tag",
      children: location.displayName
    }, location.id)), industries.map(industry => /*#__PURE__*/_jsx(ClickableTag, {
      closeable: true,
      onClick: handleClearIndustries,
      onCloseClick: handleClearIndustries,
      "data-test-id": "filter-tag",
      children: industry.name
    }, industry.id)), companies.map(company => /*#__PURE__*/_jsx(ClickableTag, {
      closeable: true,
      onClick: handleClearCompanies,
      onCloseClick: handleClearCompanies,
      "data-test-id": "filter-tag",
      children: company.name
    }, company.id)), products.length + goals.length + locations.length + industries.length + companies.length > 0 && /*#__PURE__*/_jsx(ClearButton, {
      "data-test-id": "filter-clear-button",
      onClick: () => {
        handleClearProducts();
        handleClearGoals();
        handleClearLocations();
        handleClearIndustries();
        handleClearCompanies();
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "connectDotCom.clearFilters"
      })
    })]
  });
};

export default FilterTags;